// extracted by mini-css-extract-plugin
export var component = "ArticleMeta-module--component--88e50";
export var date = "ArticleMeta-module--date--fc0bd";
export var fadePop = "ArticleMeta-module--fade-pop--544e2";
export var flex = "ArticleMeta-module--flex--2ed37";
export var growHeightIn = "ArticleMeta-module--grow-height-in--259c3";